<template>
  <el-table
    :data="tableData"
    style="width: 100%"
    class="fifl-main-table"
    header-row-class-name="fifl-table-header-row"
    header-cell-class-name="fifl-table-header-cell"
    row-class-name="fifl-table-row"
    cell-class-name="fifl-main-table-cell"
  >
    <el-table-column
      sortable
      prop="date"
      label="Date"
      width="180"
      :filters="dateFilter"
    />
    <el-table-column
      sortable
      prop="name"
      label="Name"
      width="180"
    />
    <el-table-column
      sortable
      prop="address"
      label="Address"
    />
  </el-table>
</template>

<script>
export default {
  name: 'ElMainTable',
  data() {
    return {
      dateFilter: [
        { text: '2016-05-01', value: '2016-05-01' },
        { text: '2016-05-02', value: '2016-05-02' },
        { text: '2016-05-03', value: '2016-05-03' },
        { text: '2016-05-04', value: '2016-05-04' },
      ],
      tableData: [
        {
          date: '2016-05-03',
          name: 'Tom',
          address: 'No. 189, Grove St',
        },
        {
          date: '2016-05-02',
          name: 'Tom',
          address: 'No. 189, Grove St',
        },
        {
          date: '2016-05-04',
          name: 'Tom',
          address: 'No. 189, Grove St',
        },
        {
          date: '2016-05-01',
          name: 'Tom',
          address: 'No. 189, Grove St',
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>
